import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { APIS } from 'src/app/core/enums/apis';
import { UserTenantAccess } from 'src/app/shared/models/submodels/userTenantAccess';
import { Tenant } from 'src/app/shared/models/tenant';

export interface VideoCallSession {
    sessionId: string;
    token: string;
    apiKey: string;
}

@Injectable({ providedIn: 'root' })
export class VideoCallService {
    constructor(
        private http: HttpClient,
        private auth: AuthenticationService
    ) {}

    async createSession(attentionId: number) {

        const current = this.auth.tenantValue as Tenant | UserTenantAccess | null;
        if (!current) throw new Error('No hay un tenant seleccionado');

        const tenantCode = 'code' in current
            ? current.code?.trim()
            : (await firstValueFrom(
                this.auth.getTenantByUUID(
                    current.tenantUUID || current.tenantId
                )
            )).code?.trim();

        if (!tenantCode) throw new Error('Tenant no disponible');

        const response = await firstValueFrom(
            this.http.post<{ data: VideoCallSession }>(
                `${environment.apiVideoService}${APIS.VIDEO_SESSION}`,
                { attentionId }
            )
        );
        const session = response?.data;
        if (!session?.sessionId || !session.token || !session.apiKey) {
            throw new Error('Credenciales incompletas');
        }

        const host = environment.videoCallHost.replace(/\/$/, '');
        const link = `${host}/video/${encodeURIComponent(tenantCode)}/${encodeURIComponent(session.sessionId)}`;
        return { ...session, link };
    }

    disableSession(sessionId: string) {
        return this.http.patch(
            `${environment.apiVideoService}${APIS.VIDEO_SESSIONS}/${encodeURIComponent(sessionId)}`,
            { enabled: false }
        );
    }
}
